export default class Gallery {
	constructor(element) {
		this.intervalMs = 800;

		this.element = element;
		this.slides = Array.from(element.querySelectorAll('.m-gallery__project'));
		this.current = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
		this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		if (this.current === -1) {
			this.current = 0;
		}

		if (this.slides.length < 2) {
			return;
		}

		this.paused = false;
		this.interval = null;

		this.playButton = element.querySelector('[data-gallery-play]');

		this.next = this.next.bind(this);
		this.onPlayClick = this.onPlayClick.bind(this);

		this.playButton?.addEventListener('click', this.onPlayClick);

		if (!this.prefersReducedMotion) {
			this.play();
		} else {
			this.setPaused(true);
		}
	}

	next() {
		this.slides[this.current].classList.remove('is-active');
		this.current = (this.current + 1) % this.slides.length;
		this.slides[this.current].classList.add('is-active');
	}

	play() {
		if (this.interval) {
			return;
		}

		this.interval = window.setInterval(this.next, this.intervalMs);
	}

	pause() {
		if (!this.interval) {
			return;
		}

		window.clearInterval(this.interval);
		this.interval = null;
	}

	setPaused(paused) {
		this.paused = paused;

		this.element.classList.toggle('is-paused', paused);
		this.playButton?.setAttribute('aria-label', paused ? 'Diashow afspelen' : 'Diashow pauzeren');

		if (paused) {
			this.pause();
		} else {
			this.play();
		}
	}

	onPlayClick() {
		this.setPaused(!this.paused);
	}

	destroy() {
		this.pause();
		this.playButton?.removeEventListener('click', this.onPlayClick);
	}
}
